<ion-header>
  <ion-toolbar>
    <ion-title>{{ name }}</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="toggleSidebar()" color="primary">
        @if (!isSidebarVisible) {
          <ion-icon name="grid-outline"/>
        }
        @if (isSidebarVisible) {
          <ion-icon name="grid"/>
        }
      </ion-button>
    </ion-buttons>
    @if (isDownloadEnabled && !!downloadUri) {
      <ion-buttons slot="start">
        <ion-button (click)="save()" color="primary">
          <ion-icon name="save"/>
        </ion-button>
      </ion-buttons>
    }
    <ion-buttons slot="end">
      <ion-button (click)="exit()" color="primary">
        <ion-icon name="close"/>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-searchbar (ionBlur)="onResizeWorkaround()"
                 (ionChange)="onSearch($event)"
                 [placeholder]=" 'COMPONENTS.ATTACHMENTS.SEARCH.PLACEHOLDER' | translate"
                 [showClearButton]="isTextSearch ? 'always' : 'never'"
                 debounce="100"
  />
</ion-header>
<ion-content scroll-y="false">
  <div class="pdf-wrapper">
    <ngx-extended-pdf-viewer (currentZoomFactor)="zoomChange($event)"
                             (pagesLoaded)="pagesLoaded($event)"
                             [(page)]="currentPage"
                             [(sidebarVisible)]="isSidebarVisible"
                             [handTool]="false"
                             [height]="(viewerHeightSubject | async) ?? 'unset'"
                             [showToolbar]="false"
                             [src]="file.file"
                             [textLayer]="true"
                             [zoom]="zoomLevel"
    />
  </div>
  <ion-fab class="fab-zoom" horizontal="start" slot="fixed" vertical="bottom">
    <ion-row>
      <ion-col>
        <ion-fab-button (click)="shiftZoom(-1)">
          <ion-icon name="remove"/>
        </ion-fab-button>
      </ion-col>
      <ion-col>
        <ion-fab-button (click)="shiftZoom(1)">
          <ion-icon name="add"/>
        </ion-fab-button>
      </ion-col>
    </ion-row>
  </ion-fab>
  @if (!isTextSearch) {
    <ion-fab class="fab-paging" horizontal="end" slot="fixed" vertical="bottom">
      <ion-row>
        <ion-col>
          <ion-fab-button (click)="shiftPage(-1)" [disabled]="currentPage === 1">
            <ion-icon name="chevron-back"/>
          </ion-fab-button>
        </ion-col>
        <ion-col>
          <ion-fab-button (click)="shiftPage(1)" [disabled]="currentPage === pagesCount">
            <ion-icon name="chevron-forward"/>
          </ion-fab-button>
        </ion-col>
      </ion-row>
    </ion-fab>
  }
  @if (isTextSearch) {
    <ion-fab class="fab-paging" horizontal="end" slot="fixed" vertical="bottom">
      <ion-row>
        <ion-col>
          <ion-fab-button (click)="searchNext()" [disabled]="currentPage === 1">
            <ion-icon name="caret-back-outline"/>
          </ion-fab-button>
        </ion-col>
        <ion-col>
          <ion-fab-button (click)="searchPrev()" [disabled]="currentPage === pagesCount">
            <ion-icon name="caret-forward-outline"/>
          </ion-fab-button>
        </ion-col>
      </ion-row>
    </ion-fab>
  }
</ion-content>
